import { Plus, Search, MapPin } from 'lucide-react'
import { useState } from 'react'

export default function RegioesPage() {
  const [search, setSearch] = useState('')

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-neutral-900">Regiões</h1>
          <p className="text-neutral-500 mt-1">Organize bairros, distritos e zonas eleitorais</p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2.5 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-lg text-sm transition-colors">
          <Plus className="w-4 h-4" />
          Nova Região
        </button>
      </div>

      <div className="bg-white rounded-xl border border-neutral-200 p-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
          <input type="text" value={search} onChange={e => setSearch(e.target.value)}
            placeholder="Buscar região..."
            className="w-full pl-10 pr-4 py-2.5 border border-neutral-300 rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" />
        </div>
      </div>

      <div className="bg-white rounded-xl border border-neutral-200 p-12 text-center">
        <MapPin className="w-16 h-16 text-neutral-300 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-neutral-700 mb-2">Nenhuma região cadastrada</h3>
        <p className="text-neutral-500 mb-6 max-w-md mx-auto">
          Cadastre regiões para mapear sua atuação política por área geográfica.
        </p>
        <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-lg text-sm transition-colors">
          <Plus className="w-4 h-4" /> Cadastrar Região
        </button>
      </div>
    </div>
  )
}
